import { OrderSocketMessage } from '../enums/order-socket-message.enum';

export class WebsocketPayTransactionPayload {
	message: string = OrderSocketMessage.PAYTRANSACTION;
	checkKey: string;
	invoiceNo: string;
	transactionAmount: number;
	transactionTip: number;
	transactionTax: number;
	destinationLicenseKey: string; // the licenseKey responible for the payment transaction
	payTransactionKey: string; //unique identifier of the pay transaction
	payTransactionRequestSourceKey: string; //indicates the license that requested the payment transaction

	public constructor(init?: Partial<WebsocketPayTransactionPayload>) {
		Object.assign(this, init);
	}
}
